export default "__VITE_ASSET__CwtJGqfG__"